import type { ISourceOptions } from '@tsparticles/engine';

/**
 * Real fire particle effect configuration for torch ceremony
 * Creates animated flames rising upward from the bottom of the screen
 */
export const FIRE_EFFECT_OPTIONS: ISourceOptions = {
  fullScreen: {
    enable: true,
    zIndex: 2000, // Above Chakra modals
  },
  fpsLimit: 60,
  particles: {
    number: {
      value: 0, // Controlled by emitter
    },
    color: {
      value: ['#fdcf58', '#f27d0c', '#ff4500', '#800909'], // Fire gradient
    },
    opacity: {
      value: { min: 0.1, max: 0.8 },
      animation: {
        enable: true,
        speed: 1,
        sync: false,
      },
    },
    size: {
      value: { min: 1, max: 4 },
      animation: {
        enable: true,
        speed: 5,
        sync: false,
      },
    },
    move: {
      enable: true,
      speed: { min: 3, max: 8 },
      direction: 'top',
      outModes: {
        default: 'destroy',
      },
      gravity: {
        enable: true,
        acceleration: -0.5, // Negative = rises upward (like flames)
      },
    },
    life: {
      duration: {
        value: 2,
      },
    },
    wobble: {
      enable: true,
      distance: 10,
      speed: 10,
    },
  },
  emitters: {
    position: {
      x: 50,
      y: 90,
    },
    rate: {
      delay: 0.02,
      quantity: 3,
    },
    size: {
      width: 100,
      height: 0,
      mode: 'percent',
    },
    life: {
      duration: 2, // Emitter runs for 2 seconds then stops
      count: 1,
    },
  },
};

/**
 * Creates fire effect options with custom duration
 */
export const createFireEffectOptions = (durationSeconds: number = 2): ISourceOptions => ({
  ...FIRE_EFFECT_OPTIONS,
  emitters: {
    ...(FIRE_EFFECT_OPTIONS.emitters as object),
    life: {
      duration: durationSeconds,
      count: 1,
    },
  },
});
